export const PAYMENT_PREFIX = {
  STORE: 'STORE',
  SCAN_TO_PAY: 'SCAN_TO_PAY',
};
